/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maccaption_MccInputs */

const en_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

const fr_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

const de_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

const it_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

const ru_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

const es_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título de Mac (.mcc)`)
};

const zh_cn2_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

const ja_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マックキャプション (.mcc)`)
};

const hi_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैककैप्शन (.mcc)`)
};

const pt_pt2_maccaption_mcc = /** @type {(inputs: Maccaption_MccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacCaption (.mcc)`)
};

/**
* | output |
* | --- |
* | "MacCaption (.mcc)" |
*
* @param {Maccaption_MccInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maccaption_mcc = /** @type {((inputs?: Maccaption_MccInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maccaption_MccInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_maccaption_mcc(inputs)
	if (locale === "de") return de_maccaption_mcc(inputs)
	if (locale === "it") return it_maccaption_mcc(inputs)
	if (locale === "ru") return ru_maccaption_mcc(inputs)
	if (locale === "es") return es_maccaption_mcc(inputs)
	if (locale === "zh-CN") return zh_cn2_maccaption_mcc(inputs)
	if (locale === "ja") return ja_maccaption_mcc(inputs)
	if (locale === "hi") return hi_maccaption_mcc(inputs)
	if (locale === "pt-PT") return pt_pt2_maccaption_mcc(inputs)
	return en_maccaption_mcc(inputs)
});